import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";


const Career = () => {
  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* Header */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Career"} />

        <section className="course-details py-60">
          <div className="container">
            <div className="row gy-4">
              <div className="col-xl-12">
                {/* Details Content Start */}
                <div className="course-details__content border border-neutral-30 rounded-12 bg-main-25 p-12">
                  <div className="p-20">
                    <p className="text-neutral-700">
                      We seek educators that are open-minded, passionate about
                      education and children, and committed to lifelong
                      learning.
                      <br />
                      Interested candidates should email their resume at&nbsp;
                      <a
                        href="mailto:hr@npskudlu.com"
                        className="text-main-600 hover-text-decoration-underline fw-medium"
                      >
                        hr@npskudlu.com
                      </a>{" "}
                      or mail it to our address provided below:
                      <br />
                      <br />
                      <b>National Public School</b>
                      <br /> 148, Singasandra, Kudlu,
                      <br /> Bangalore – 560 068
                      <br /> Karnataka.
                      <br />
                      <b>Phone:</b>{" "}
                      <a
                        href="tel:+919731226002"
                        className="text-main-600 hover-text-decoration-underline fw-medium"
                      >
                        +91 9731226002
                      </a>
                      <br />
                      <b>Email:</b>{" "}
                      <a
                        href="mailto:hr@npskudlu.com"
                        className="text-main-600 hover-text-decoration-underline fw-medium"
                      >
                        hr@npskudlu.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Career;
